module.exports = __webpack_public_path__ + "img/2.8140656c.png";